// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.lr-progress-overlay {
    position: absolute;
    left: 0;
    top: 0;
    z-index: 2000;
    width: 100vw;
    height: 100vh;
    background-color: #fff;
    display: flex;
}
.lr-progress-container {
    display: flex;
    position: relative;
    margin-left: auto;
    margin-right: auto;
    align-self: center;
}
.lr-verticle-line {
    position: absolute;
    left: 11px;
    height: 98%;
    border-left: solid 1px #e6e6e6;
}
.lr-progress-container ul {
    padding: 0;
    margin: 0;
    z-index: 10;
}
.lr-progress-container ul li {
    list-style: none;
    margin-bottom: 1.5rem;
    display: flex;
    align-items: center;
}
.lr-progress-container ul li:last-child {
    margin-bottom: 0;
}
.progress-icon{
    width: 23px;
    height: 23px;
    margin-right: 12px;
}
.lr-close-btn {
    position: absolute;
    right: 32px;
    top: 16px;
}

@media(min-width: 768px) {
    .lr-close-btn {
        right: 64px;
        top: 32px;
    }
}

.olr-icon-progress-default {
    background-image: url('icon-progress-default.svg');
    width: 24px;
    height: 20px;
    background-repeat: no-repeat;
    background-size: contain;
    display: block;
}`, "",{"version":3,"sources":["webpack://./projects/lossreporting-library/src/lib/shared/progress/progress-indicator/progress-indicator.component.css"],"names":[],"mappings":"AAAA;IACI,kBAAkB;IAClB,OAAO;IACP,MAAM;IACN,aAAa;IACb,YAAY;IACZ,aAAa;IACb,sBAAsB;IACtB,aAAa;AACjB;AACA;IACI,aAAa;IACb,kBAAkB;IAClB,iBAAiB;IACjB,kBAAkB;IAClB,kBAAkB;AACtB;AACA;IACI,kBAAkB;IAClB,UAAU;IACV,WAAW;IACX,8BAA8B;AAClC;AACA;IACI,UAAU;IACV,SAAS;IACT,WAAW;AACf;AACA;IACI,gBAAgB;IAChB,qBAAqB;IACrB,aAAa;IACb,mBAAmB;AACvB;AACA;IACI,gBAAgB;AACpB;AACA;IACI,WAAW;IACX,YAAY;IACZ,kBAAkB;AACtB;AACA;IACI,kBAAkB;IAClB,WAAW;IACX,SAAS;AACb;;AAEA;IACI;QACI,WAAW;QACX,SAAS;IACb;AACJ;;AAEA;IACI,kDAAuE;IACvE,WAAW;IACX,YAAY;IACZ,4BAA4B;IAC5B,wBAAwB;IACxB,cAAc;AAClB","sourcesContent":[".lr-progress-overlay {\n    position: absolute;\n    left: 0;\n    top: 0;\n    z-index: 2000;\n    width: 100vw;\n    height: 100vh;\n    background-color: #fff;\n    display: flex;\n}\n.lr-progress-container {\n    display: flex;\n    position: relative;\n    margin-left: auto;\n    margin-right: auto;\n    align-self: center;\n}\n.lr-verticle-line {\n    position: absolute;\n    left: 11px;\n    height: 98%;\n    border-left: solid 1px #e6e6e6;\n}\n.lr-progress-container ul {\n    padding: 0;\n    margin: 0;\n    z-index: 10;\n}\n.lr-progress-container ul li {\n    list-style: none;\n    margin-bottom: 1.5rem;\n    display: flex;\n    align-items: center;\n}\n.lr-progress-container ul li:last-child {\n    margin-bottom: 0;\n}\n.progress-icon{\n    width: 23px;\n    height: 23px;\n    margin-right: 12px;\n}\n.lr-close-btn {\n    position: absolute;\n    right: 32px;\n    top: 16px;\n}\n\n@media(min-width: 768px) {\n    .lr-close-btn {\n        right: 64px;\n        top: 32px;\n    }\n}\n\n.olr-icon-progress-default {\n    background-image: url(../../../../assets/img/icon-progress-default.svg);\n    width: 24px;\n    height: 20px;\n    background-repeat: no-repeat;\n    background-size: contain;\n    display: block;\n}"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
